import { render, staticRenderFns } from "./exibir-tipo-deficiencia.vue?vue&type=template&id=045efc81&"
import script from "./exibir-tipo-deficiencia.vue?vue&type=script&lang=ts&"
export * from "./exibir-tipo-deficiencia.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('045efc81')) {
      api.createRecord('045efc81', component.options)
    } else {
      api.reload('045efc81', component.options)
    }
    module.hot.accept("./exibir-tipo-deficiencia.vue?vue&type=template&id=045efc81&", function () {
      api.rerender('045efc81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tipo-deficiencia/exibir-tipo-deficiencia.vue"
export default component.exports